import { Directive } from '@angular/core';

@Directive({
  selector: '[space-button]',
  standalone: true,
  host: {
    'class': 'mat-button space-button' // add any other class like mat-raised-button
  }
})
export class SpaceButtonDirective {

  constructor() { }

}
